import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';
import { css } from 'emotion';
import ProcessValidator from 'utils/ProcessValidator';
import ProcessUtils from 'utils/ProcessUtils';
import Constants from 'utils/Constants';
import ModalsService from 'services/ModalsService';
import SecurityService from 'services/SecurityService';
import ProcessService from 'services/ProcessService';
import { colorOrange, colorBrightRed, colorTextGrey, colorVeryLightBlue, colorBorderGrey } from 'styles/base';


const headingStyles = css`
    background-color: ${colorVeryLightBlue}
`;

const rowStyles = css`
    &:hover {
        cursor: pointer;
    }
    &.e-error, &.e-error button.ant-btn { 
            color: ${colorBrightRed} !important;
        }
    &.e-warning, &.e-warning button.ant-btn {
        color: ${colorOrange} !important;
    }
    &.e-ignored, &.e-ignored button.ant-btn {
        color: ${colorTextGrey} !important;
    }
    &.e-error, &.e-warning {
        button.ant-btn[disabled] {
            color: ${colorTextGrey} !important;
        }
    }
    td.type {
        white-space: nowrap;
        .fa {
            margin-right:3px !important;
        }
    }
`;

const ignoreButton = css`
    display:inline-block;
    padding: 6px 12px;
    border: 1px solid ${colorBorderGrey};
    border-radius: 4px;
`;


class ValidationRollupModal extends React.Component {
    static propTypes = {
        errorList: PropTypes.array,
        currentUser: PropTypes.string,
        processId: PropTypes.string,
        process: PropTypes.object
    };

    onAllAction = () => {
        const editor = ProcessUtils.getEditor(this.props.process);
        //ignore all
        let value = true;

        if (this.areAllIgnored()) {
            //reactivate all
            value = false;
        }
        this.props.errorList.forEach(err => {
            editor.updateField(['ui_state', 'ignore_validation', this.props.currentUser, err.key], value);
        });
        editor.commit();
    };

    onOk = () => {
        if (!this.isDisabled()) {
            ProcessService.saveIgnoreValidation(this.props.processId);
        }
        ModalsService.closeModal(ModalsService.TYPE_VALIDATION);
    };

    isDisabled = () => {
        return this.props.currentUser === null;
    };

    ignoreRule = (key) => {
        const ignoredValidation = ProcessUtils.getIgnoredValidation(this.props.process.name);
        let value = true;
        if (ignoredValidation) {
            value = !ignoredValidation[key];
        }

        const editor = ProcessUtils.getEditor(this.props.process);
        editor.updateField(['ui_state', 'ignore_validation', this.props.currentUser, key], value);
        editor.commit();
    };

    areAllIgnored = () => {
        const topError = ProcessValidator.getRollupError(this.props.errorList, this.props.processId);
        return topError && topError.level === Constants.LEVEL_IGNORE;
    };

    renderFieldLabel = (err) => {
        if (err.fieldPath && err.fieldPath.length > 3) {
            const chunk1 = err.fieldPath.slice(0, 2);
            let chunk2 = err.fieldPath.slice(2, err.fieldPath.length - 1);
            if (chunk1[1] === 'output_datastream_variable_mappings') {
                //output variable mappings need full path?
                chunk2 = err.fieldPath.slice(2, err.fieldPath.length);
            }
            return (
                <span>
                    {chunk1.join('.')}<br/>.{chunk2.join('.')}
                </span>
            );
        }

        return err.key;
    };

    renderErrorRows = () => {
        const ignoredValidation = ProcessUtils.getIgnoredValidation(this.props.process.name);
        const disabled = this.isDisabled();
        return this.props.errorList.map(err => {
            let ignored = false;
            if (ignoredValidation) {
                ignored = !!ignoredValidation[err.key];
            }

            let className = err.level;
            if (ignored) {
                className = 'ignored';
            }

            const icon = ignored ? 'fa-eye' : 'fa-eye-slash';
            let title = `${ignored ? 'Reactivate' : 'Ignore'} this validation warning`;
            if (disabled) {
                title = 'You are not logged in';
            }

            return (
                <tr key={err.key} className={`${rowStyles} e-${className}`}>
                    <td className="type"><i className={'fa fa-exclamation-triangle'}/>{err.level}</td>
                    <td>{err.message}</td>
                    <td>{this.renderFieldLabel(err)}</td>
                    <td>
                        <Button className={ignoreButton} onClick={() => {this.ignoreRule(err.key)} } disabled={disabled} title={title}>
                            <i className={`fa ${icon}`}/>
                        </Button>
                    </td>
                </tr>
            );
        });
    };

    render() {

        const allIgnored = this.areAllIgnored();
        const allButtonLabel = allIgnored ? 'Reactivate All' : 'Ignore All';

        return (
            <React.Fragment>
                <Modal.Header>
                    <Modal.Title>Validation Report for {this.props.processId}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="scrollable">
                    <table className={'table table-bordered table-striped'}>
                        <thead className={headingStyles}>
                            <tr>
                                <th>Type</th>
                                <th>Message</th>
                                <th>Field</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderErrorRows()}
                        </tbody>
                    </table>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.onAllAction} type="primary" disabled={this.isDisabled()}>
                        {allButtonLabel}
                    </Button>
                    <Button autoFocus onClick={this.onOk}>
                        OK
                    </Button>
                </Modal.Footer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (storeState, ownProps) => {
    const processState = ProcessService.getMyState(storeState);
    const securityState = SecurityService.getMyState(storeState);
    const currentUser = securityState.username;
    const process = processState.workingCopiesById[ownProps.processId];

    return {
        currentUser,
        process
    };
};


export default connect(mapStateToProps)(ValidationRollupModal);


// WEBPACK FOOTER //
// ./src/components/core/modals/ValidationRollupModal.js